import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import type { LalSegmentApi } from '@openx/types/segments.ts';
import { useTranslation } from 'react-i18next';

type Props = {
  data: LalSegmentApi[];
  setConfirmationDisabled?: (disabled: boolean) => void;
};

export const ArchiveLalSegmentDialogContent = ({ data }: Props) => {
  const { t } = useTranslation();

  const segmentsText = data.length > 1 ? t('segments') : t('segment');

  return (
    <Grid sx={{ p: 2 }}>
      <Typography>{t("You're about to archive the following LAL {segmentsText}:", { segmentsText })}</Typography>

      {data.map(segment => (
        <Typography variant="body1Bold" key={segment.id}>
          {segment.lookalike_name}
        </Typography>
      ))}

      <Typography sx={{ mt: 2 }}>{t('Do you want to proceed?')}</Typography>
    </Grid>
  );
};
